/* eslint-disable jsx-a11y/label-has-associated-control */

import React, { useRef, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import ImageUploader from 'components_newui/new_ui_image_uploader/View'
import { useFormContext,Controller } from 'react-hook-form';
import { MyIdeaForm } from './fromGeneratorComponent';
import { safeParseJSON } from 'services/RequestUtils';

const useStyles = makeStyles((theme) => ({
    root: {
      width: '100%',
    },
    basicDetailWrp:{
        margin: '1rem 0 2rem 0',
        padding: '1rem',
        background: '#fff'
    },
    title:{
        fontFamily: 'VodafoneRg-Regular', 
        fontSize: '1.25rem',
        margin: '0 0 2rem 0', 
        textAlign: 'left',
        color:"#333",
      },
    fieldsetBox:{
        marginBottom:theme.spacing(1),
        border: 0,
        padding: 0,
        background: 'transparent',
        '& label':{
            fontFamily: 'VodafoneRg-bold', 
            fontSize: '1rem',
            margin: '0 0 0.5rem 0', 
            textAlign: 'left',
            color:"#333",
            display:'block',
        },
        '& input[type="text"],input[type="date"],select ':{
            fontFamily: 'VodafoneRg-Regular', 
            fontSize: '1rem',
            margin: '0 0 0.5rem 0', 
            textAlign: 'left',
            color:"#333",
            background:'#fff',
            borderRadius:'4px',
            width: '100%',
            minHeight: '3rem',
            border: '1px solid #333',
            padding: '0.5rem',
            boxSizing: 'border-box',
        },
        '& input[type=date]:before':{content:'none'},
        '& textarea':{
            fontFamily: 'VodafoneRg-Regular', 
            fontSize: '1rem',
            margin: '0 0 0.5rem 0', 
            textAlign: 'left',
            color:"#333",
            background:'#fff',
            borderRadius:'4px',
            width: '100%',
            minHeight: '8.5rem',
            border: '1px solid #333',
            padding: '0.5rem',
            boxSizing: 'border-box',
            resize:'none'
        },
        
        
        
    },
    '& input[aria-invalid="true"]':{
        borderColor:'red',
    },
    error:{
        color:"red",
        fontFamily: 'VodafoneRg-Regular', 
        fontSize: '1rem',
        margin: '0 0 0.5rem 0', 
    },
    labelname:{
        fontFamily: 'VodafoneRg-bold', 
        fontSize: '1rem',
        margin: '0 0 0.5rem 0', 
        textAlign: 'left',
        color:"#333",
        display:'block',
    },
    
    invalid: {
        borderColor: 'red !important',
    },
    
    wrp2cols:{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '1rem'
    },
    backButton: {
      marginRight: theme.spacing(1),
    },
    instructions: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
  }));
  

export const IdeaGenerateForm = (props) => {
  // console.log("🚀 ~ IdeaGenerateForm ~ props:", props)
  // const {getInnovateIdeaTemplateIdJson,formData,childToParentformDatatoUpdate,getAnswerFromIdeaToDynamicForm, nextStepsAfterFormSubmit} = props || {}

  const {getInnovateIdeaTemplateIdJson,handleFormChange,getAnswerFromIdeaToDynamicForm,nextStepsAfterFormSubmit , formData} = props || {}
    // console.log("🚀 ~ IdeaGenerateForm ~ getInnovateIdeaTemplateIdJson:", getInnovateIdeaTemplateIdJson)
    // console.log("🚀 ~ IdeaGenerateForm ~ getInnovateIdeaTemplateIdJson:", getInnovateIdeaTemplateIdJson)
    const {ideaTemplate,ideaTemplateAnswers} = formData || {}
    // console.log("🚀 ~ IdeaGenerateForm ~ ideaTemplateAnswers:", ideaTemplateAnswers)
  const [isValidField, setIsValidField] = useState(false);
  const classes = useStyles();
  const { register, control,  watch,trigger, formState: { errors } } = useFormContext();

//  console.log('useFormContext', trigger)

  // const handleNextStepFormSubmition = async () =>{
  //   const isValid = await trigger();
  //   setIsValidField(isValid)
  // }

// const handleFormChange = (data) => {
//   console.log('Received from child:', data);
//   // setFormDataJson(data);
// };

// console.log("paranet formData: ",formDataJson)

// let merged
// if(!formDataJson){
//    merged =  getInnovateIdeaTemplateIdJson.map(item => {
//     const match = formDataJson.find(o => o.id === item.id);
//     console.log("value merge:", match)
//     return {
//       ...item,
//       value: match ? match.value : item.value
//     };
//   });
// }

// console.log('jsonforn output:---', merged);

// const validJsonString = ideaTemplate.replace(/'/g, '"');

const convertIdeaTemplate =safeParseJSON(ideaTemplate || []);
// console.log("🚀 ~ IdeaGenerateForm ~ convertIdeaTemplate:",  ideaTemplate , "ideaTemplate ", convertIdeaTemplate , typeof ideaTemplate)

// const validJsonStringAns = ideaTemplateAnswers.replace(/'/g, '"');

// const convertIdeaTemplateAns =safeParseJSON(ideaTemplateAnswers || []);

// console.log("🚀 ~ IdeaGenerateForm ~ convertIdeaTemplateAns:", convertIdeaTemplateAns, getAnswerFromIdeaToDynamicForm)
// console.log("🚀 ~ IdeaGenerateForm ~ convertIdeaTemplateAns:", convertIdeaTemplateAns, typeof ideaTemplateAnswers)

// console.log("🚀 ~ IdeaGenerateForm ~ convertIdeaTemplate:", convertIdeaTemplate,convertIdeaTemplateAns)


// const convertIdeaTemplateAns =safeParseJSON(ideaTemplateAnswers || []);

let convertIdeaTemplateAns = null;
let err = null;

try {
  convertIdeaTemplateAns = JSON.parse(ideaTemplateAnswers);
} catch (e) {
  err = e;
  console.error('JSON parse error:', err);
}


// Merge template with answers
// const mergedTemplate = (getInnovateIdeaTemplateIdJson || []).map(field => {
//   const matchedAnswer = (convertIdeaTemplateAns || [])?.find(ans => ans?.id === field?.id);
//   return {
//     ...field,
//     value: matchedAnswer ? matchedAnswer?.value : field?.value || ''
//   };
// });
// console.log("🚀 ~ IdeaGenerateForm ~ mergedTemplate:", mergedTemplate)

const syncedAnswers = (convertIdeaTemplateAns || []).map((original) => {
  // console.log("🚀 ~ IdeaGenerateForm ~ original:", original)
  const updated = getAnswerFromIdeaToDynamicForm.find((latest) => latest.id === original.id);
  // console.log("🚀 ~ IdeaGenerateForm ~ updated:", updated)
  return {
    ...original,
    value: updated ? updated.value : original.value
  };
});
// console.log("🚀 ~ IdeaGenerateForm ~ syncedAnswers:", syncedAnswers)

  return (
    <div className={classes.basicDetailWrp}>
        {/* <h2 className={classes.title}> idea dynamic form</h2> */}
          <MyIdeaForm 
            // ref={formRef}
            // jsonResponseFromIdIdeaTemplate={ Array.isArray(convertIdeaTemplate) ? convertIdeaTemplate : []}
            // jsonResponseFromIdIdeaTemplate={ getInnovateIdeaTemplateIdJson || []}
            // convertIdeaTemplateAns = {Array.isArray(convertIdeaTemplateAns) ? convertIdeaTemplateAns : [] }
            // onFormChange={childToParentformDatatoUpdate}
            // handleNext={nextStepsAfterFormSubmit}
            SaveData={syncedAnswers || []}
            // SaveData={convertIdeaTemplateAns}
            // setIdeaFormData={setIdeaFormData}
            jsonResponseFromIdIdeaTemplate={getInnovateIdeaTemplateIdJson}
            onFormChange={handleFormChange}
            handleNext={nextStepsAfterFormSubmit}
          />

    </div>
  )
}
